module.exports = __webpack_public_path__ + "img/logo3.5536d4c7.png";